<template>
  <v-btn
    icon
    @click="switchTheme()"
  >
    <v-icon
      v-if="!isDark"
      color="primary"
    >
      fas fa-sun
    </v-icon>
    <v-icon
      v-else
      color="primary"
    >
      fas fa-moon
    </v-icon>
  </v-btn>
</template>

<script>
  export default {
    name: 'ThemeSwitcherApp',
    computed: {
      isDark () {
        return this.$vuetify.theme.dark
      },
    },
    mounted () {
      const setLight = localStorage.getItem('dark') === 'true'
      this.$vuetify.theme.dark = setLight
    },
    methods: {
      switchTheme () {
        this.$vuetify.theme.dark = !this.isDark
        localStorage.setItem('dark', this.isDark)
      },
    },
  }
</script>
